import logo from './logo.svg';
import './App.css';
import Landing from './Landing';
import { BrowserRouter } from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Landing />
      </div>
    </BrowserRouter>
  );
}

export default App;
